
import { Component, Vue} from 'vue-property-decorator';

import { namespace } from "vuex-class";   
import "@/store/modules/application";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
import { stepInfoType } from '@/types/Application';
const applicationState = namespace("Application");

@Component
export default class NavigationSidebar extends Vue {
    
    @applicationState.State
    public steps!: stepInfoType[]; 

    @applicationState.State
    public currentStep!: number;
    
    @applicationState.State
    public allCompleted!: boolean

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    error = "";
    updateSidebar = 0;

    public onSelectStep(event) {
    
        const otherStep = this.stPgNo.OTHER._StepNo

        const next = event.currentTarget;
        const nextIndex = parseInt(next.getAttribute("index"));

        if(nextIndex == this.stPgNo.SUBMIT._StepNo && this.steps[0].result?.otherForms &&
           this.steps[otherStep].result?.otherFormsSurvey?.data?.filingMethod == "inPerson" && 
           this.requiresOtherNextStep(this.steps[otherStep].result?.completeOtherFormsSurvey.data.selectedFormInfoList)
        ){
            this.$store.commit("Application/setCurrentStepPage", {currentStep: this.stPgNo.SUBMIT._StepNo, currentPage: this.stPgNo.SUBMIT.NextSteps });
        }
        else if(nextIndex == this.stPgNo.SUBMIT._StepNo && this.steps[0].result?.otherForms){            
            this.$store.commit("Application/setCurrentStepPage", {currentStep: this.stPgNo.SUBMIT._StepNo, currentPage: this.stPgNo.SUBMIT.OtherFile });
        }
        else if(nextIndex == this.stPgNo.SUBMIT._StepNo && !this.allCompleted){
            this.$store.commit("Application/setCurrentStepPage", {currentStep: this.stPgNo.SUBMIT._StepNo, currentPage: this.stPgNo.SUBMIT.FilingOptions });
        }
        
        this.$store.commit("Application/setCurrentStep", nextIndex);
        Vue.nextTick().then(()=>{Vue.prototype.$saveChanges();});
    }
   
    public onSelectPage(event) {
        const currStepIndex = this.$store.state.Application.currentStep;
        const nextPage = event.currentTarget;
        const nextPageIndex = parseInt(nextPage.getAttribute("index"));

        if(this.$store.state.Application.steps[currStepIndex].pages[nextPageIndex].progress == 0) return

        this.$store.commit("Application/setCurrentStepPage", {currentStep: currStepIndex, currentPage: nextPageIndex });
        Vue.nextTick().then(()=>{Vue.prototype.$saveChanges();});
    }

    public getNavigation(): stepInfoType[] {       
        return this.$store.state.Application.steps;
    }

    public getStepDisplayNumber(stepIndex) {
        const steps = this.getNavigation();
        let stepDisplayNumber = Number(stepIndex) + 1;  // convert 0-based index number to 1-based display number

        for (let i = stepIndex - 1; i >= 0; i--) {
            if (!steps[i].active) {
            // adjust display number
                stepDisplayNumber--;
            }
        }

        return stepDisplayNumber;
    }

    public isCurrentStep(stepIndex) {
        return this.$store.state.Application.currentStep == stepIndex;
    }

    public getStepId(stepIndex) {
        return "step-" + stepIndex;
    }

    public getStepGroupId(stepIndex) {
        return this.getStepId(stepIndex) + "-group";
    }

    public getStepPageId(stepIndex, pageIndex) {
        return this.getStepId(stepIndex) + "-page-" + pageIndex;
    }

    public isPrintStep(step) {
        return step.type=='print';
    }
    
    public isStepTouched(nextStepIndex){
        const selectedStep = this.$store.state.Application.steps[nextStepIndex];
        for(const page of selectedStep.pages){
            if(page.progress > 0) return true;
        }
        return false
    }

    public getPageProgress(stepIndex, pageIndex){
        return this.$store.state.Application.steps[stepIndex].pages[pageIndex].progress
    }

    public requiresOtherNextStep(selectedFormInfoList){
        
        for (const selectedForm of selectedFormInfoList){
            if (!selectedForm.manualState){
                return false;
            }            
        }
        return true;
    }

}
